import { render, staticRenderFns } from "./ChatBotDemo.vue?vue&type=template&id=5fa8a9ea&scoped=true&"
import script from "./ChatBotDemo.vue?vue&type=script&lang=js&"
export * from "./ChatBotDemo.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotDemo.vue?vue&type=style&index=0&id=5fa8a9ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa8a9ea",
  null
  
)

export default component.exports